import styled from "styled-components"

// Component
import Copyright from "./Copyright"

export default styled(Copyright)`
  color: rgba(216, 226, 255, 0.5);
  font-size: 14px;
`
